<template>
  <div class="con-out">
    <div class="cell large-font" @click="_toHomePage">
      管理后台
    </div>
    <section v-for="(item, index) in tap" :key="index" style="width: 100%" @click="_toPage(item.id)">
      <div v-if="item.select" class="cell bottom-border select">
        {{ item.label }}
      </div>
      <div v-else class="cell bottom-border un-select">
        {{ item.label }}
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AdminLeft",
  data() {
    return {
      tap: [
        {
          label: '去官网首页',
          select: false,
          id: 2,
          name: ''
        },
        {
          label: '首页管理',
          select: true,
          id: 0,
          name: 'adminHome'
        },
        {
          label: '文章管理',
          select: false,
          id: 1,
          name: 'adminArticle'
        },
        {
          label: 'banner管理',
          select: false,
          id: 4,
          name: 'adminBanner'
        },
        {
          label: '修改密码',
          select: false,
          id: 3,
          name: 'adminPassword'
        }
      ]
    }
  },
  mounted() {
    const path = this.$route.name
    for (let i = 0; i < this.tap.length; i++) {
      this.tap[i].select = this.tap[i].name === path
    }
  },
  methods: {
    _toAdminBanner() {
      this.$router.push({
        path: '/AdminBanner'
      })
    },
    _toAdminPassword() {
      this.$router.push({
        path: '/AdminPassword'
      })
    },
    _toHomePage() {
      this.$router.push({
        path: '/AdminHome'
      })
    },
    _toArticlePage() {
      this.$router.push({
        path: '/AdminArticle'
      })
    },
    _toPage(e) {
      switch (parseInt(e)) {
        case 0:
          this._toHomePage()
          break
        case 1:
          this._toArticlePage()
          break
        case 2:
          // eslint-disable-next-line no-case-declarations
          const routeData = this.$router.resolve({
            path: "/"
          })
          window.open(routeData.href, '_blank')
          break
        case 3:
          this._toAdminPassword()
          break
        case 4:
          this._toAdminBanner()
          break
        default:
          this._toHomePage()
      }
    }
  }
}
</script>

<style scoped>
.con-out {
  width: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background: #0091e6;
  color: #ffffff;
}

.cell {
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
}

.bottom-border {
  border-bottom: solid 1px #f2f2f2;
}

.large-font {
  font-weight: bold;
  font-size: 20px;
  background: #414143;
}

.select {
  background: #3a6ec1;
}

.un-select {
  background: #0091e6;
}
</style>